import React, { ReactElement, useContext } from 'react'

import Heading from '../../../Common/Components/Heading'
import P from '../../../Common/Components/P'

import { LanguageContext } from '../../../Common/Contexts'

import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { Preview as PreviewLanguage } from '../../../../../i18n'
import { HeadingLevel } from '../../../Common/Components/Heading/Heading'
// CSS imports. Commented out because of current build process.
// import './preview.scss'

/**
 * Component properties type.
 */
type Props = {
    previewValue: string | undefined
}

/**
 * Preview component for the example value in currently selected currency.
 *
 * @param previewValue Example value in preview.
 */
const Preview: React.FC<Props> = ({ previewValue }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('Preview')

    return (
        <div className='preview'>
            <Heading level={HeadingLevel.ONE}>{language?.get(PreviewLanguage.PreviewHeader)}</Heading>
            <P>{previewValue || language?.get(PreviewLanguage.PreviewValueInvalid)}</P>
        </div>
    )
}

export default Preview
